<template>
    <div>
        <portal-navbar> </portal-navbar>

        <fade-transition :duration="200" origin="center top" mode="out-in">
            <router-view class="px-4 full-height rounded-0 customer-potal-layout" :style="customColor"></router-view>
        </fade-transition>
    </div>
</template>

<script>
import PortalNavbar from './PortalNavbar'
import { FadeTransition } from 'vue2-transitions'

export default {
    components: {
        PortalNavbar,
        FadeTransition,
    },
    mounted() {
        this.$store.dispatch('company/fetch')
    },
    computed: {
        customColor() {
            const data = this.$store.state.company.settings || {}
            const colors = {
                'background-color': data.background_color + "!important",
                color: data.text_color + "!important"
            }
            return colors
        }
    }
}
</script>
